import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a2c573e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__crumbs" }
const _hoisted_2 = { class: "crumbs__list" }

import { reactive } from 'vue';
import router from '@/router';
import { ICrumbs } from '@/components/_types';
import { RouteNames } from '@/router/names';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageCrumbs',
  props: {
    crumbs: null
  },
  setup(__props: any) {

const props = __props as {
  crumbs: ICrumbs[];
};



const { crumbs } = reactive(props);

const routeMain = (): void => {
  router.push({ name: RouteNames.landing });
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _withDirectives(_createVNode(_component_font_awesome_icon, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (routeMain())),
      icon: "fa-solid fa-arrow-left"
    }, null, 512 /* NEED_PATCH */), [
      [_vShow, _unref(crumbs) && _unref(crumbs).length !== 0]
    ]),
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        class: "crumbs",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (routeMain()))
      }, "Main"),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(crumbs), (crumb) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "crumbs",
          key: crumb.id
        }, _toDisplayString(crumb.way), 1 /* TEXT */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}
}

})